<header class="main-header">
  <div class="flex items-center">
    @if (unCollapsed) {
      <div
        (click)="collapseSidebar()"
        class="mr-2 cursor-pointer border border-l-0 border-light-grey p-2"
      >
        <fip-svg size="24" fill="#B9B9B9" name="collapse"></fip-svg>
      </div>
    }
    <a routerLink="/">
      <!-- New icon -->
      @if (
        showLogo &&
        featureFlags.getFeatureAreaVisibility('newFipLogo') === 'enabled'
      ) {
        <img
          class="h-5 pl-2 md:h-10 md:pl-4"
          src="assets/images/logos/fip.svg"
          alt="fip_logo"
        />
      }
      <!-- Legacy icon -->
      @if (
        showLogo &&
        featureFlags.getFeatureAreaVisibility('newFipLogo') !== 'enabled'
      ) {
        <img
          class="h-10 pl-4"
          src="assets/images/fip_logo.png"
          alt="fip_logo"
        />
      }
    </a>
  </div>

  @if (router.url.includes('/parts')) {
    <fip-production-order-navigation
      class="center-navigation"
    ></fip-production-order-navigation>
  }

  <div class="flex items-center justify-center">
    <!-- Support -->
    <!-- <a
    mat-icon-button
    color="primary"
    target="_blank"
    href="https://www.fraenkische.com/en/"
    >
    <mat-icon fontIcon="support_agent"></mat-icon>
  </a> -->

    @if (featureFlags.getFeatureAreaVisibility('alerting') !== 'hidden') {
      <button
        mat-icon-button
        color="primary"
        [disabled]="
          featureFlags.getFeatureAreaVisibility('alerting') === 'disabled'
        "
        [matMenuTriggerFor]="notificationMenu"
      >
        <mat-icon
          [matBadge]="unreadCount$ | async"
          [matBadgeHidden]="(unreadCount$ | async) === 0"
          matBadgeColor="warn"
          matBadgeSize="small"
          aria-hidden="false"
          data-cy="notification-badge"
          >notifications</mat-icon
        >
      </button>
    }

    <!-- Notification Menu -->
    <mat-menu #notificationMenu="matMenu" class="notification-menu">
      @if (notifications$ | async; as notifications) {
        @if (notifications.length > 0) {
          @for (notification of notifications; track notification) {
            <button
              mat-menu-item
              [ngClass]="{ unread: !notification.isRead }"
              (click)="navigateToAlert(notification)"
            >
              <span>{{ notification.message }}</span>
            </button>
          }
        } @else {
          <button mat-menu-item disabled>
            <span>No new notifications</span>
          </button>
        }
      }
    </mat-menu>

    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
      <mat-icon fontIcon="settings"></mat-icon>
    </button>

    <mat-menu class="text-center" #menu="matMenu">
      <div class="font-bold">Roles: {{ roles$ | async }}</div>

      <button mat-menu-item (click)="reloadPermissions()">
        Reload permissions
      </button>
    </mat-menu>

    @if (user?.isLoggedIn) {
      <div class="flex flex-row items-center text-xs xl:text-sm">
        <!-- User email -->
        <div>
          <span class="mx-2">{{ user?.username }}</span>
        </div>
        <!-- Logout button -->
        <div class="border-l border-light-grey pl-2">
          <button
            mat-flat-button
            (click)="logout()"
            class="select-none px-2 py-1 !text-xs text-dark-grey hover:border-black hover:bg-accent-yellow xl:!text-sm"
          >
            LOGOUT
          </button>
        </div>
      </div>
    }
  </div>
</header>
